'use client';

import React, {FC} from 'react';

import styles from './styles.module.scss';

interface DisclosuresProps {
  backgroundColor?: string;
}

const Disclosures: FC<DisclosuresProps> = ({backgroundColor = '#ffffff'}) => (
  <section className="section-data" style={{backgroundColor}}>
    <div className="default-container">
      <p className={styles.disclosures}>
        Disclosure: This page is not investment advice and should not be relied
        on for such advice or as a substitute for consultation with professional
        accounting, tax, legal or financial advisors. The observations of
        industry trends should not be read as recommendations for stocks or
        sectors.
      </p>
    </div>
  </section>
);

export default Disclosures;
